import React from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";

export default function App() {
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    const fullScreen = {
        position: "fixed",
        top: 0, left: 0,
        width: "100vw",
        height: "100vh",
        margin: 0,
        padding: 0,
        overflow: "hidden",
    };

    return (
        <div style={fullScreen}>
            <>
                <iframe
                    src={`/app.html`}
                    title="G3 Closure Quote Builder"
                    style={{
                        display: "block",
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#0a2342",
                        border: "none",
                        margin: 0,
                        padding: 0
                    }}
                />
            </>
        </div>
    );
}
